export default {
  journalizing_to_esdh_system: 'Journalisering i ESDH-system',
  esdh_file_manage_page_description: 'Her kan du se alle de sikre filer, som fejlede ved afsendelse til ESDH-systemet.',
  esdh_file_manage_data_description:
    'Fejloplysningerne er også sendt til din kommunale administrator, som kan forsøge at få løst fejlene via supporten.',
  esdh_file_manage_manual_journalizing_description:
    'Såfremt dette ikke er muligt, kan filerne blive markeret til at skulle journaliseres manuelt.',
  esdh_file_manage_manual_journalizing_instruction:
    'Når du vælger én eller flere filer, får du mulighed for at {exportText} dem eller markere dem som {journalizedManuallyText}.',
  esdh_file_manage_system_page_description:
    'Her kan du se alle de sikre filer, som fejlede ved afsendelse til ESDH-systemet for institutionerne i din kommune.',
  esdh_file_manage_system_journalizing_instruction:
    'Når du vælger én eller flere filer, får du mulighed for at {resendText} dem eller markere at de skal {journalizedManuallyText}.',
  esdh_file_manage_system_journalizing_description:
    'Bliver filerne markeret til at skulle journaliseres manuelt, vil institutionsadministratoren blive adviseret herom, og filerne fjernet fra tabellen.',
  notification_settings_email_required: 'Du skal indtaste mindst én korrekt e-mailadresse',
  files: 'Filer',
  title: 'Titel',
  handling_status: 'Status for håndtering',
  export_status: 'Eksportstatus',
  export: 'eksportere',
  exported: 'Eksporteret',
  resend: 'gensende',
  journalized_manually: 'journaliseret manuelt',
  journalize_manually: 'journaliseres manuelt',
  unexported: 'Ikke eksporteret',
  journalized_by: 'Journaliseret af',
  sent_time: 'Afsendelsestidspunkt',
  number_of_selected: '{number} valgt',
  awaiting_municipal_admin_status: 'Afventer kommunal administrator.',
  manually_journalized_status: 'Skal journaliseres manuelt.',
  filter_all: 'Alle',
  error_code: 'Fejlkode',
  long_system_name: 'Navnet må ikke være længere end 15 tegn',
  empty_system_name: 'Navnet er ugyldigt',
  system_name_guiding: 'Vær opmærksom på, at navnet udstilles for medarbejderne i Aula.',
  app_notification_description: 'Indstillinger for mobil-notifikationer skal foretages i Aulas app',
  locked_by_central_admin: 'Låst af central administrator',
  locked_by_municipal_admin: 'Låst af kommunal administrator',
  unlocked_by_municipal_admin: 'Oplåst af kommunal administrator',
  recommended_by_central_admin: 'Anbefalet af central administrator',
  recommended_by_municipal_admin: 'Anbefalet af kommunal administrator',
  self_selected: 'Valgt af dig',
  self_deselected: 'Skjult af dig',
  show_for_institution: 'Vis modul som standard for institutioner',
  hide_for_institution: 'Skjul modul som standard for institutioner',
  lock_for_institution: 'Lås dette valg for alle institutioner',
  limit_to_selected_groups: 'Begræns valget til specifikke grupper',
  module_configuration_description_municipal:
    'Her vælges hvilke moduler og widgets, der skal vises i dashboards. Når du vælger at vise eller skjule, er det en anbefaling til institutionsadministratoren samt standardindstillingen for nye institutioner. Hvis du vælger at låse valget, kan institutionsadministratorerne ikke ændre dette. Hvis du låser valget, vil de institutioner, der har en anden indstilling, få denne overskrevet.',
  module_configuration_description_institutional:
    'Her vælges hvilke moduler og widgets, der skal vises for brugere på din institution. Visse moduler kan være låst enten på centralt eller kommunalt niveau - disse kan ikke ændres.',
  module_configuration_help_text_municipal:
    'Hvis du vælger at skjule og låse et modul, slettes alle tilknyttede notifikationer samt badgenotifikationer (de røde prikker med talangivelse) for brugerne automatisk.',
  module_configuration_help_text_institutional:
    'Hvis du vælger at skjule et modul, som tidligere er blevet vist, slettes alle tilknyttede notifikationer samt badgenotifikationer (de røde prikker med talangivelse) for brugerne automatisk.',
  lock_module_warning: 'Du er ved at låse følgende moduler',
  lock_module_help_text:
    'Når moduler låses, vil det slå igennem for <strong>alle</strong> institutioner i din kommune. Institutionsadministratorer kan <strong>ikke</strong> overskrive denne handling.',
  lock_module_help_text_with_restricted_groups:
    'Når moduler låses, vil det slå igennem for <strong>alle</strong> institutioner (eller valgte grupper) i din kommune. Institutionsadministratorer kan <strong>ikke</strong> overskrive denne handling.',
  lock_module_disabled: 'Modulet skjules for alle institutioner.',
  lock_module_enabled: 'Modulet låses og vises for alle institutioner, når du gemmer.',
  lock_module_enabled_with_restricted_groups:
    'Modulet låses og vises for alle institutioner (eller valgte grupper), når du gemmer.',
  group_home_admin_add_user_placeholder: 'Angiv de 10 cifre i CPR-nummeret eller brugernavn fra Unilogin',
};
